import { render, staticRenderFns } from "./MeituanVerificationRecord.vue?vue&type=template&id=8b38c8d0&scoped=true"
import script from "./MeituanVerificationRecord.vue?vue&type=script&lang=js"
export * from "./MeituanVerificationRecord.vue?vue&type=script&lang=js"
import style0 from "./MeituanVerificationRecord.vue?vue&type=style&index=0&id=8b38c8d0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b38c8d0",
  null
  
)

export default component.exports